import { gql } from '@apollo/client';
import Fragments from './fragments';

export const CONTENT_TYPE_QUERY = gql`
  query contentType($id: Int!) {
    contentType(id: $id) {
      ...contentType
    }
  }
  ${Fragments.contentType}
`;

export const CONTENT_TYPE_X_METADATA = gql`
  query contentTypeXMetadata($contentTypeId: Int!) {
    contentTypeXMetadata(contentTypeId: $contentTypeId) {
      id
      contentTypeId
      metadataId
      mandatory
    }
  }
`;

export const METADATA_LIST_QUERY = gql`
  query metadata {
    metadata {
      id
      code
      name
    }
  }
`;

export const CONTENT_TYPE_X_USER_GROUPS = gql`
  query contentTypeXUserGroups($contentTypeId: Int!) {
    contentTypeXUserGroups(contentTypeId: $contentTypeId) {
      ...contentTypeXUserGroup
    }
  }
  ${Fragments.contentTypeXUserGroup}
`;

export const USER_GROUPS_LIST_QUERY = gql`
  query userGroupsList {
    userGroupsList {
      id
      name
    }
  }
`;